import React from 'react'
import { Registry } from '@react-registry'
import { elementCategories } from '../../elementCategories'
import { cx, css } from '@emotion/css'
//@ts-ignore
import styles from '../style.module.css'

export * from './deserializer'

export const H5 = (props) => {
  const { className } = props.attrs || {}
  return (
    <div {...props.attrs} className={styles['heading']}>
      <h5 {...props.attributes} className={cx(
        className,
        css`padding-top: var(--scrte-padding-top, 0);`
      )}>
        {props.children}
      </h5>
    </div>
  )
}
Registry.register(
  {
    Component: H5,
    // iconName: 'ri-h-5',
    title: <h5 className={styles['h5']}>Heading 5</h5>,
    subtitle: 'Add heading level 5',
    category: elementCategories.TEXT_FORMAT,
    shortcut: { key: 'mod+alt+5' },
    isContentStackElement: true,
    inBasicToolbar: true
  },
  { id: 'h5', registry: 'element' }
)
